import { render, staticRenderFns } from "./livePlan.vue?vue&type=template&id=4800c66b&scoped=true&"
import script from "./livePlan.vue?vue&type=script&lang=js&"
export * from "./livePlan.vue?vue&type=script&lang=js&"
import style0 from "./livePlan.vue?vue&type=style&index=0&id=4800c66b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4800c66b",
  null
  
)

component.options.__file = "livePlan.vue"
export default component.exports